import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import TitleRow, {TitleAction} from "../../../../shared/components/TitleRow";
import {CreateProductTitleBar} from "../../../../configs/products";
import CancelModal from "../../../../shared/components/CancelModal";
import {WarningProductModal} from "../../../../configs/warningProductModal";

interface TitleProps {
	setValidated: Function;
	title: string;
	handleSubmit: Function;
	isLoading?: boolean;
}


const Title = ({setValidated, title, handleSubmit, isLoading = false}: TitleProps) => {
	const navigate = useNavigate();
	const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
	const titleActions: TitleAction[] =  [
		{
			title: CreateProductTitleBar.cancelButton,
			onClick: () => {
				setIsOpenCancelModal(true);
			},
		},
		{
			title: "Lưu thông tin",
			variant: "contained",
			isLoading,
			onClick: () => {
				if (isLoading) return;
				setValidated(true)
				handleSubmit();
			},
		},
	];

	return (
		<>
			<TitleRow title={title} actions={titleActions} />
			{isOpenCancelModal && (
				<CancelModal
					open={isOpenCancelModal}
					title={WarningProductModal.title}
					contentText={WarningProductModal.context}
					handleConfirm={() => navigate("/dashboard/")}
					handleClose={() => setIsOpenCancelModal(false)}
				/>
			)}
		</>
	);
}

export default Title;
